// extracted by mini-css-extract-plugin
export default {"copilot":"Copilot_copilot__xyCpZ"};